import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit'
import { Draft } from 'immer'
import { firstValueFrom } from 'rxjs'
import { POST_TYPE_STORY } from 'shared/constants'
import { BackgroundTemplate, FBAlbum } from 'shared/types'
import StoreState, { createAppAsyncThunk } from 'store/state'
import { facebookBackgroundTemplatesSelector } from '../selectors'
import ComposerState from '../state'
import { V1 } from './net'
import { PostDestination } from 'shared'

export const facebookReducers = {
  toggleFBPostReshare: (state: Draft<ComposerState>) => {
    state.posts.facebook.reshare = !state.posts.facebook.reshare
  },
  selectComposerFBAlbum: (
    state: Draft<ComposerState>,
    action: PayloadAction<{ profile: PostDestination, album: FBAlbum | undefined }>
  ) => {
    const { profile, album } = action.payload
    const index = state.posts.facebook.albums.findIndex(a => a.ppid === profile.ppid)
    if (index !== -1) {
      state.posts.facebook.albums.splice(index, 1)
    }
    if (album) {
      state.posts.facebook.albums.push(album)
    }
  },
  setFBPostType: (state: Draft<ComposerState>, action: PayloadAction<string | undefined>) => {
    const value = action.payload === 'post' ? undefined : action.payload
    state.posts.facebook.postType = value
    state.posts.facebook.reshare = value === POST_TYPE_STORY ? false : state.posts.facebook.reshare
    if (state.video?.url) {
      state.posts.facebook.lastUsedVideoPostType = action.payload as any
    }
  },
  setFacebookTextBackground: (state: Draft<ComposerState>, action: PayloadAction<BackgroundTemplate | undefined>) => {
    state.posts.facebook.textBackground = action.payload
  },
  setDefaultFBBackgroundTemplateId: (state: Draft<ComposerState>, action: PayloadAction<string | undefined>) => {
    state.defaultFacebookBackgroundTemplateId = action.payload
  }
}

export const facebookExtraReducers = (builder: ActionReducerMapBuilder<ComposerState>) => {
  builder.addCase(getFacebookPostTemplates.fulfilled, (state, action) => {
    state.facebookBackgroundTemplates = action.payload
  })
}

export const getFacebookPostTemplates = createAppAsyncThunk(
  'composer/facebook/getPostTemplates',
  async (force: boolean = false, { dispatch, getState }) => {
    if (!force) {
      const cached = facebookBackgroundTemplatesSelector(getState() as StoreState)
      if (cached.length > 0) {
        return cached
      }
    }
    const response = await firstValueFrom(dispatch(V1.getTemplates()))
    return response
  }
)
